import React, {useState, useEffect} from 'react';
import {Table, Button} from 'react-bootstrap';
import { useAuthState } from "react-firebase-hooks/auth";
import ReactLoading from 'react-loading';
import TourneyParticipantOverview from './tournament_participants_overview';
import {auth,db,get_all_registrable_tournaments, getValUserCredentials} from '../utils/firebase-config';
import {query,getDocs,collection,where,onSnapshot, QuerySnapshot} from "firebase/firestore";
function TourneyOngoingTable() {
    const [user, loading, error] = useAuthState(auth);
    const [allongoingtournaments, setAllOngoingTournaments] = useState([]);
    const [usercred, setUserCred] = useState("td");
    const [Loading, setLoading] = useState(true) 
    const [name, setName] = useState(false);

    const fetchUserName = async () => {
        try {
          const q = query(collection(db, "users"), where("uid", "==", user?.uid));
          console.log(user?.uid);
          const doc = await getDocs(q);
          const data = doc.docs[0].data();
          setName(data.valorant_name);
          console.log(data.valorant_name);

        } catch (err) {
          console.error(err);
          setName("You magnificent creature");
        }
    };

    const checkopentournaments = async() => {
        console.log(name);
        onSnapshot(querytourneys, (snapshot) =>{
            setAllOngoingTournaments(snapshot);
            setLoading(false);
        });
      }

    const checkusercreds = async() => {
        getValUserCredentials(user?.uid).then((rs) => {
            setUserCred(rs);
        });
        if (usercred == "moderator") {
            console.log("welcome mod");
        }
        if(usercred == "error") {
            setLoading(true);
        }else{
            console.log("TBD");
        }
        console.log(name);
    }

    function ModButton(props) {
        const cred = props.usercred;
        if(cred == "user"){
            return(<></>)
        }if(cred == "moderator"){
            return(
                <Button type="success">moderator button</Button>
            )
        }else{
            return(<></>)
        }
    }
    const querytourneys = query(collection(db,"registration_tournament"), where("open", "==", false), where("ongoing","==",true));
    useEffect(() => {
        setLoading(true);
        checkusercreds();
        fetchUserName();
    }, [])

    useEffect(() => {
        setLoading(true);
        checkopentournaments();
    }, [name])

    //<TourneyParticipantOverview username={name} tournamentname={tournament.data().tournament_name}></TourneyParticipantOverview>
    function DisplayOngoing(props) {
        const rs = props.ongoing
        console.log(rs.docs);
        if(rs.docs.length == 0){
            return (
                <>
                    <br />
                    <h5>no tournaments ongoing</h5>
                </>
            )
        }else{
            return(
            <div>
                <Table striped bordered>
                    <thead >
                        <tr>
                            <th>name tournament</th>
                            <th>game</th>
                            <th>participants</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rs.docs.map((tournament) => {
                        return  <>
                            <tr>
                                <td> <a href={'/tournament/' + tournament.id}>{tournament.data().tournament_name}</a>
                                    <ModButton usercred={usercred}></ModButton>
                                </td>
                                <td>{tournament.data().game}</td>
                                <td>
                                    <TourneyParticipantOverview tournamentname={tournament.data().tournament_name} nparticipants={tournament.data().participants.length}></TourneyParticipantOverview>
                                </td>
                            </tr>
                        </>
                        })}
                    </tbody>
                </Table>
            </div>  )
        }
    }

    if(Loading){
    return(
    <div className="busy">
        <ReactLoading className="loadingbar" type='bars' color='grey' height={'20vw'} width={'20vw'} />
    </div>
    )
    }
    else{
        return (
            <DisplayOngoing ongoing={allongoingtournaments}></DisplayOngoing>  
        )
    }


    
}

export default TourneyOngoingTable